import { useState, useCallback, useRef } from 'react';
import _ from 'lodash';

export const useMutable = (source) => {
  // Only deep-clone the initial value once
  const initialRef = useRef(_.cloneDeep(source));

  // Local mutable state
  const [value, setValue] = useState(initialRef.current);

  // Update deep values safely
  const handleUpdate = useCallback((updater) => {
    setValue(prev => {
      const draft = _.cloneDeep(prev);
      updater(draft);
      return draft;
    });
  }, []);

  // Reset back to original input if needed
  const handleReset = useCallback(() => {
    const resetValue = _.cloneDeep(source);
    initialRef.current = resetValue;
    setValue(resetValue);
  }, [source]);

  return { value, handleUpdate, handleReset, setValue };
};
